import { FC } from "react";
import { Spin } from "antd";

export const CustomFormsLoading: FC = () => {
  return <Spin />;
};
